"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.NotesFooter = exports.TextArea = exports.TextAreaContainer = exports.NotesHeader = exports.Container = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const buttons_1 = require("../buttons");
const styled_1 = __importDefault(require("../../styles/styled"));
exports.Container = (0, styled_1.default)('div')(({ theme }) => ({
    position: 'relative',
    width: '80vw',
    maxHeight: '60vh',
    height: '60vh',
    display: 'flex',
    flexDirection: 'column',
    padding: `
        ${theme.space[5]}px
        ${theme.space[5]}px`,
    background: theme.colors.white,
    boxShadow: theme.shadow.large,
    overflow: 'auto',
    borderRadius: '4px',
}));
exports.NotesHeader = (0, styled_1.default)('div')(({ theme }) => ({
    width: '100%',
    height: '50px',
    display: 'flex',
    justifyContent: 'space-between',
}));
exports.TextAreaContainer = (0, styled_1.default)('div')(({ theme }) => ({
    width: '100%',
    flex: '1 1 auto',
    padding: `${theme.space[4]}px 0`,
}));
exports.TextArea = (0, styled_1.default)('textarea')(({ theme }) => ({
    width: '100%',
    height: '100%',
    fontSize: theme.text.size.medium,
    padding: theme.space[3],
    fontFamily: theme.text.bodyFontFamily,
    backgroundColor: theme.colors.grey05,
    border: `2px solid ${theme.colors.grey05}`,
    borderRadius: theme.radii[1],
    resize: 'none',
    outline: 'none',
    overflowY: 'scroll',
}));
exports.NotesFooter = (0, styled_1.default)('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
}));
const CloseButton = (props) => ((0, jsx_runtime_1.jsx)(buttons_1.IconButton, { iconName: "CloseIcon", size: "medium", shape: "circle", label: "close", onClick: props.onClick, background: "azure", fill: "white", "data-testid": props.id, type: "button" }));
exports.CloseButton = CloseButton;
//# sourceMappingURL=in_call_notes_styles.js.map